import { http } from './config'

export default {
    getMarcasComProdutos: () => {
        return http.get('marca/marcas-com-produtos')
    }
}